import { PersonaEligibility } from 'se-resource-types/dist/lib/EligibilitySearchService'

interface EligibilityRule {
  linked_eligibility_rule_set_id?: string | null
  originator_type?: string
}

type HydratedPersonaEligibility = PersonaEligibility & {
  eligibility_rule_set?: {
    eligibility_rules?: EligibilityRule[]
  }
}

/**
 * Removes parent membership eligibilities when a child membership eligibility for the
 * same persona links to them.
 */
export function filterLinkedParentEligibilities<T extends PersonaEligibility>(
  personaEligibilities: T[]
): T[] {
  const linkedParentIdsByPersona = new Map<string, Set<string>>()

  for (const personaEligibility of personaEligibilities as HydratedPersonaEligibility[]) {
    const personaKey = String(personaEligibility.persona_id)
    const linkedParentIds = linkedParentIdsByPersona.get(personaKey) ?? new Set<string>()

    for (const rule of personaEligibility.eligibility_rule_set?.eligibility_rules ?? []) {
      if (rule.originator_type !== 'membership_definition' || !rule.linked_eligibility_rule_set_id) continue

      linkedParentIds.add(rule.linked_eligibility_rule_set_id)
    }

    linkedParentIdsByPersona.set(personaKey, linkedParentIds)
  }

  return personaEligibilities.filter(personaEligibility =>
    !linkedParentIdsByPersona
      .get(String(personaEligibility.persona_id))
      ?.has(personaEligibility.eligibility_rule_set_id)
  )
}
